import round from 'lodash.round'
import useGlobalStore from '@/store/useGlobalStore'

type GetFixedCurrencyOptions = {
  amount: number | string
  currencyCode?: string
  decimals?: number
  withCurrencySymbol?: boolean
}

export const getFixedCurrency = ({
  amount,
  currencyCode,
  decimals = 2,
  withCurrencySymbol = true,
}: GetFixedCurrencyOptions): string => {
  let currency = currencyCode

  if (!currency) {
    // Since this is not a hook, we need to access the store directly
    const state = useGlobalStore.getState()
    currency = state.app.marketExceptions?.currencyCode || 'USD'
  }

  const numericValue =
    typeof amount === 'string' ? Number.parseFloat(amount) : amount

  if (Number.isNaN(numericValue)) {
    return new Intl.NumberFormat('en-US', {
      style: withCurrencySymbol ? 'currency' : 'decimal',
      ...(withCurrencySymbol && { currency }),
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(0)
  }

  const roundedValue = round(numericValue, decimals)

  return new Intl.NumberFormat('en-US', {
    style: withCurrencySymbol ? 'currency' : 'decimal',
    ...(withCurrencySymbol && { currency }),
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(roundedValue)
}
